import App from "./App.ce.vue";

export const setup = () => {
  return Object.freeze({
    component: App,
  });
};
